import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  Activity,
  GetProjectActivityRequestProps
} from "Api/activity/types";

export const getProjectActivityRequest = ({
  projectId,
  activityId
}: GetProjectActivityRequestProps) =>
  apiProxyRequest<Activity>(`/projects/${projectId}/activities/${activityId}`);
